export default {
  "content": "<g clip-path=\"url(#icon_nav-bookkeping_svg__a)\"><path fill-rule=\"evenodd\" d=\"M13.67 2.67h-.34V1.04c0-.57-.46-1.04-1.04-1.04H3.17C2.15 0 1.33.82 1.33 1.83l.02.17h-.02v13c0 .55.45 1 1 1h11.34c.55 0 1-.45 1-1V3.67c0-.56-.45-1-1-1zM3.17 1h9.12l.04.04v1.59l-.04.04H3.17c-.46 0-.84-.38-.84-.84 0-.46.38-.83.84-.83zM5 3.67h2.67v3.72l-1.33-.95L5 7.39V3.67zM13.67 15H2.33V3.67H4v4.81c0 .36.41.56.7.36l1.64-1.17 1.63 1.17c.29.2.7 0 .7-.36V3.67h5V15z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"icon_nav-bookkeping_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};